/** FRU-24782: a tap that lands on the form within this long of a step change belongs to the tap that left the previous
 *  question. On a phone the next question appears under the finger, and the second tap of a quick double tap answered it
 *  too (a double tap on "Single Family" also answered how the property is used). Only real taps and clicks count: a
 *  programmatic click is never held, and neither is a keyboard or assistive-technology press (a click whose detail is 0). */
export const TAP_CARRYOVER_MS = 500;

export function tapIsCarryover(now: number, stepAdvancedAt: number, fromPointer: boolean, onTheForm: boolean): boolean {
  return fromPointer && onTheForm && !!stepAdvancedAt && now >= stepAdvancedAt && now - stepAdvancedAt < TAP_CARRYOVER_MS;
}

/** A real tap or mouse click, as opposed to a programmatic click or a keyboard press (both report detail 0). */
export function clickIsFromPointer(event: { isTrusted: boolean; detail: number }): boolean {
  return !!event && event.isTrusted === true && (event.detail || 0) > 0;
}

/** The hold's start time after a step change: now when the form moved forward, 0 when it went back (Back starts no hold
 *  and ends any left from the step before, so a deliberate quick re-answer goes through). */
export function holdStampAfterStepChange(previousIndex: number, nextIndex: number, now: number): number {
  return typeof previousIndex === 'number' && typeof nextIndex === 'number' && nextIndex > previousIndex ? now : 0;
}
